import React, { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
// import logo from '../../assets/wemeetto logo.svg';
import logo from '../../assets/wemeettologowhite.svg'
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // Shadow on scroll
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname, location.search, location.hash]);

  // Close on ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') setMobileOpen(false);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [mobileOpen]);

  const isLandingPage = location.pathname === '/';

  const smoothScroll = useCallback((id) => {
    const el = document.getElementById(id);
    el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setMobileOpen(false);
  }, []);

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : ''}`}>
      <div className="nav-container">
        <div className="nav-logo">
          <Link to="/" aria-label="Wemeetto home">
            <img src={logo} alt="Wemeetto" className="logo-image" />
          </Link>
        </div>

        {/* Desktop links */}
        <div className="nav-links" role="navigation" aria-label="Primary">
          {isLandingPage ? (
            <>
              <button onClick={() => smoothScroll('features')} className="nav-link">Features</button>
              <button onClick={() => smoothScroll('about')} className="nav-link">About</button>
              <button onClick={() => smoothScroll('contact')} className="nav-link">Contact</button>
            </>
          ) : (
            <>
              <Link to="/" className="nav-link">Home</Link>
              <Link to="/faq" className="nav-link">FAQ</Link>
              <Link to="/privacy" className="nav-link">Privacy</Link>
              <Link to="/terms" className="nav-link">Terms</Link>
            </>
          )}
        </div>

        {/* Mobile menu button */}
        <button
          className="menu-button"
          aria-label={mobileOpen ? 'Close menu' : 'Open menu'}
          aria-expanded={mobileOpen}
          aria-controls="mobile-menu"
          onClick={() => setMobileOpen((o) => !o)}
        >
          {mobileOpen ? (
            // X icon
            <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 1 0 5.7 7.11L10.59 12 5.7 16.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4Z"/>
            </svg>
          ) : (
            // Hamburger icon
            <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
              <path fill="currentColor" d="M3 6h18v2H3V6Zm0 5h18v2H3v-2Zm0 5h18v2H3v-2Z"/>
            </svg>
          )}
        </button>
      </div>

      {/* Mobile drawer + backdrop */}
      <div
        className={`mobile-backdrop ${mobileOpen ? 'show' : ''}`}
        onClick={() => setMobileOpen(false)}
      />
      <aside
        id="mobile-menu"
        className={`mobile-menu ${mobileOpen ? 'open' : ''}`}
        role="dialog"
        aria-modal="true"
        aria-label="Mobile navigation"
      >
         <div className="mobile-menu-header">
           <button
             className="mobile-back-btn"
             aria-label="Close menu"
             onClick={() => setMobileOpen(false)}
           >
             <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
               <path fill="currentColor" d="M15.7 5.3a1 1 0 0 1 0 1.4L11.41 11l4.3 4.3a1 1 0 0 1-1.42 1.4l-5-5a1 1 0 0 1 0-1.4l5-5a1 1 0 0 1 1.41 0Z"/>
             </svg>
           </button>
           <span className="mobile-menu-title">Menu</span>
         </div>
         <div className="mobile-menu-inner">
          {isLandingPage ? (
            <nav className="mobile-nav-items">
              <button className="mobile-link" onClick={() => smoothScroll('features')}>Features</button>
              <button className="mobile-link" onClick={() => smoothScroll('about')}>About</button>
              <button className="mobile-link" onClick={() => smoothScroll('contact')}>Contact</button>
            </nav>
          ) : (
            <nav className="mobile-nav-items">
              <Link className="mobile-link" to="/" onClick={() => setMobileOpen(false)}>Home</Link>
              <Link className="mobile-link" to="/faq" onClick={() => setMobileOpen(false)}>FAQ</Link>
              <Link className="mobile-link" to="/privacy" onClick={() => setMobileOpen(false)}>Privacy</Link>
              <Link className="mobile-link" to="/terms" onClick={() => setMobileOpen(false)}>Terms</Link>
            </nav>
          )}
        </div>
      </aside>
    </nav>
  );
};

export default Navbar;
